module.exports = __webpack_public_path__ + "static/media/print-slash.41fa5b47.svg";